import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import client from './rest/AdminClient';
var api1 = 'api/1/';
const ajax = {
    get: function (url) {
        return client({
            method: 'GET',
            path: url,
        });
    },
    method: function (method, url, data) {
        return client({
            method: method.toUpperCase(),
            path: url,
            entity: JSON.stringify(data),
        });
    },
};
export function getContracts() {
    return ajax.get(api1 + 'contracts')
        .then(function (res) {
        AdminServerActionCreators.receiveContracts(res.entity.contracts);
        return res;
    })
        .catch(function (err) {
        console.log(err.stack || err);
    });
}
export function addContract(contract) {
    return ajax.method('post', api1 + 'contracts', contract)
        .then(function (res) {
        AdminServerActionCreators.receiveAddContractSuccess(res.entity);
        return res;
    })
        .catch(function (err) {
        console.log(err.stack || err);
    });
}
export function updateContract(contract) {
    var entity = { contract: contract };
    return ajax.method('patch', api1 + 'contracts/' + contract._id, entity)
        .then(function (res) {
        AdminServerActionCreators.receiveUpdateContractSuccess(res.entity);
        return res;
    })
        .catch(function (err) {
        console.log(err.stack || err);
        AdminServerActionCreators.receiveUpdateContractFail(err);
    });
}
